import React, { useCallback, useEffect, useMemo, useState } from 'react';

import alert from '../../helpers/alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import styles from './sheetSync.module.css';
import LinkEditor from './LinkEditor';
import { deleteSheetLink, getSheetLinks, saveSheetLinks } from '../../api/prices';
import { LINK_SOURCE, LINK_STATUS, deltaText, formatShort, linkNeedsAttention, money } from './sheetSyncFormat';

const FILTERS = [
  ['all', 'ÐÑÐµ'],
  ['attention', 'Ð¢ÑÐµÐ±ÑÑÑ Ð²Ð½Ð¸Ð¼Ð°Ð½Ð¸Ñ'],
  ['manual', 'ÐÑÐ¸Ð²ÑÐ·Ð°Ð½Ñ Ð²ÑÑÑÐ½ÑÑ'],
  ['ignored', 'ÐÐµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÑÑÑÑ'],
];

const COLUMNS = 8;

const matches = (v, filter, query) => {
  if (filter === 'attention' && !linkNeedsAttention(v.status)) return false;
  if (filter === 'manual' && v.source !== 'manual') return false;
  if (filter === 'ignored' && v.status !== 'ignored') return false;
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const hay = [v.sheetKey, v.brand, v.model, v.year, v.trim, ...v.targets.map((t) => t.label)].join(' ').toLowerCase();
  return hay.includes(q);
};

// ÐÐºÐ»Ð°Ð´ÐºÐ° Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â»: Ð²ÑÐµ ÑÑÑÐ¾ÐºÐ¸ ÑÐ°Ð±Ð»Ð¸ÑÑ, Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð½ÑÐµ Ðº Ð¿ÑÐ°Ð²Ð¸Ð»Ð°Ð¼ Ð¿ÑÐ¸ÐºÐ°Ð·Ð°, Ð¾Ð´Ð½Ð¾Ð¹ Ð¿Ð»Ð¾ÑÐ½Ð¾Ð¹ ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹.
// ÐÐ´ÐµÑÑ Ð¸Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ, Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¸Ð»Ð¸ ÑÐ½ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ, ÐµÑÐ»Ð¸ ÑÑÐ¾-ÑÐ¾ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð»Ð¾ÑÑ Ð½Ðµ ÑÑÐ´Ð°
const SheetLinks = ({ marks = [] }) => {
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [filter, setFilter] = useState('all');
  const [query, setQuery] = useState('');
  const [editKey, setEditKey] = useState(null);
  // Ð¡Ð½ÑÑÐ¸Ðµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ ÑÑÑÐ¾ÐºÑ Ð² Â«ÐÑÐ¾Ð±Ð»ÐµÐ¼ÑÂ» â Ð²ÑÐ¾ÑÐ¾Ð¹ ÐºÐ»Ð¸Ðº Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ, ÐºÐ°Ðº Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð¾Ð¿Ð°ÑÐ½ÑÑ ÐºÐ½Ð¾Ð¿Ð¾Ðº
  const [confirmKey, setConfirmKey] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    getSheetLinks()
      .then((res) => setLinks(res.data || []))
      .catch((err) => {
        setLinks([]);
        alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (confirmKey == null) return undefined;
    const timer = setTimeout(() => setConfirmKey(null), 5000);
    return () => clearTimeout(timer);
  }, [confirmKey]);

  const visible = useMemo(() => (links || []).filter((v) => matches(v, filter, query)), [links, filter, query]);
  const attention = (links || []).filter((v) => linkNeedsAttention(v.status)).length;

  const save = async (v, payload) => {
    setBusy(true);
    try {
      const res = await saveSheetLinks(payload);
      if (res.data.errors?.length) {
        alert.error(res.data.errors.join('; '));
        return;
      }
      alert.success(`ÐÑÐ¸Ð²ÑÐ·ÐºÐ° ${v.sheetKey} Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð° Ð¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð°. Ð¦ÐµÐ½Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð¸ÑÑ: Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Â«Ð¢Ð°Ð±Ð»Ð¸ÑÑÂ» Ð¸ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ.`);
      setEditKey(null);
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ');
    } finally {
      setBusy(false);
    }
  };

  const unlink = async (v) => {
    if (confirmKey !== v.sheetKey) {
      setConfirmKey(v.sheetKey);
      return;
    }
    setConfirmKey(null);
    setBusy(true);
    try {
      await deleteSheetLink(v.sheetKey);
      alert.success(
        v.status === 'ignored'
          ? `${v.sheetKey} ÑÐ½Ð¾Ð²Ð° ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÑÑÑ`
          : `ÐÑÐ¸Ð²ÑÐ·ÐºÐ° ${v.sheetKey} ÑÐ½ÑÑÐ°. Ð¡ÑÑÐ¾ÐºÐ° Ð²ÐµÑÐ½ÑÐ»Ð°ÑÑ Ðº ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¸, ÐµÑÐ»Ð¸ Ð½Ðµ Ð½Ð°Ð¹Ð´ÑÑ Ð¿Ð°ÑÑ, Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð² Â«ÐÑÐ¾Ð±Ð»ÐµÐ¼Ð°ÑÂ».`
      );
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ½ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ');
    } finally {
      setBusy(false);
    }
  };

  if (loading && !links) return <div className={styles.empty}>ÐÐ°Ð³ÑÑÐ·ÐºÐ°â¦</div>;

  return (
    <>
      <details className={styles.help}>
        <summary>Ð§ÑÐ¾ ÑÑÐ¾ Ð·Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐ°</summary>
        <ul>
          <li>
            ÐÑÐ¸Ð²ÑÐ·ÐºÐ° Ð³Ð¾Ð²Ð¾ÑÐ¸Ñ ÑÐ¸ÑÑÐµÐ¼Ðµ, Ðº ÐºÐ°ÐºÐ¾Ð¼Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÑÑÐ¾ÐºÐ° ÑÐ°Ð±Ð»Ð¸ÑÑ (Ð¿Ð¾ ÐµÑ ID, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ CAR-077). ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð²
            ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð¿Ð¾ÑÐ»Ðµ ÑÑÐ¾Ð³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿Ð¸ÑÐ°ÑÑ ÐºÐ°Ðº ÑÐ³Ð¾Ð´Ð½Ð¾.
          </li>
          <li>
            Â«ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑÂ» â Ð²ÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ (Ð¸Ð»Ð¸ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾, ÐµÑÐ»Ð¸ Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ Ð´Ð²Ð¾Ð¹Ð½Ð¸Ðº ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸). ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ ÑÑÐ°Ð·Ñ;
            ÑÐµÐ½Ñ Ð¾Ð½Ð¾ Ð½Ðµ ÑÑÐ¾Ð³Ð°ÐµÑ â Ð½Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° Ð¿Ð¾Ð¿Ð°Ð´ÑÑ Ð² Â«Ð¢Ð°Ð±Ð»Ð¸ÑÐ° â Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ».
          </li>
          <li>Â«ÐÑÐ²ÑÐ·Ð°ÑÑÂ» â ÑÐ½ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ: ÑÑÑÐ¾ÐºÐ° Ð²ÐµÑÐ½ÑÑÑÑ Ðº ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¸ Ð¿ÑÐ¸ Ð½ÐµÑÐ´Ð°ÑÐµ ÑÑÐ°Ð½ÐµÑ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð¾Ð¹.</li>
          <li>ÐÑÐ»Ð¸ ÑÐµÐºÑÑ ÑÑÑÐ¾ÐºÐ¸ Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸, Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ° Ð¿ÐµÑÐµÑÑÐ°ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¾Ð²Ð°ÑÑ, Ð¿Ð¾ÐºÐ° Ð²Ñ ÐµÑ Ð½Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð·Ð°Ð½Ð¾Ð²Ð¾.</li>
        </ul>
      </details>

      <div className={styles.top}>
        <input
          className={styles.filter}
          placeholder="ÐÐ¾Ð¸ÑÐº: ID, Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ"
          aria-label="ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ°Ð¼"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <select
          className={styles.filterSelect}
          aria-label="Ð¤Ð¸Ð»ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·Ð¾Ðº"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          {FILTERS.map(([key, title]) => (
            <option key={key} value={key}>
              {title}
              {key === 'attention' ? ` (${attention})` : ''}
            </option>
          ))}
        </select>
        <span className={styles.muted}>
          ÐÐ¾ÐºÐ°Ð·Ð°Ð½Ð¾ {visible.length} Ð¸Ð· {(links || []).length}
        </span>
      </div>

      {visible.length === 0 ? (
        <div className={styles.empty}>{(links || []).length === 0 ? 'ÐÑÐ¸Ð²ÑÐ·Ð¾Ðº ÐµÑÑ Ð½ÐµÑ' : 'ÐÐ¾ ÑÑÐ»Ð¾Ð²Ð¸ÑÐ¼ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾'}</div>
      ) : (
        <table className={styles.linksTable}>
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '22%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '21%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '14%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>ID</th>
              <th>Ð¡ÑÑÐ¾ÐºÐ° ÑÐ°Ð±Ð»Ð¸ÑÑ</th>
              <th className={styles.num}>Ð¦ÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ</th>
              <th>ÐÑÐ¸Ð²ÑÐ·Ð°Ð½Ð° Ðº Ð¿ÑÐ°Ð²Ð¸Ð»Ñ</th>
              <th className={styles.num}>Ð¦ÐµÐ½Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð°</th>
              <th>Ð¡ÑÐ°ÑÑÑ</th>
              <th>ÐÐµÐ¼ Ð¸ ÐºÐ¾Ð³Ð´Ð°</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {visible.map((v) => {
              const st = LINK_STATUS[v.status] || { label: v.status, hint: '' };
              return (
                <React.Fragment key={v.sheetKey}>
                  <tr>
                    <td className={styles.cellKey}>{v.sheetKey}</td>
                    <td className={styles.ellipsis} title={v.brand != null ? `${v.brand} ${v.model} ${v.year} Â· ${v.trim}` : undefined}>
                      {v.brand != null ? `${v.brand} ${v.model} ${v.year} Â· ${v.trim}` : <span className={styles.muted}>ÑÑÑÐ¾ÐºÐ¸ Ð½ÐµÑ Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ</span>}
                    </td>
                    <td className={styles.num}>{money(v.price)}</td>
                    <td className={styles.ellipsisCell}>
                      {v.status === 'ignored' ? (
                        <span className={styles.muted}>Ð½Ðµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÑÑÑ</span>
                      ) : (
                        v.targets.map((t) => (
                          <span className={styles.targetLine} key={t.id} title={`${t.mark} ${t.label}`}>
                            <span className={styles.muted}>{t.mark}</span> {t.label}
                          </span>
                        ))
                      )}
                    </td>
                    <td className={styles.num}>
                      {v.status !== 'ignored' &&
                        v.targets.map((t) => (
                          <span className={styles.targetLine} key={t.id}>
                            {t.rulePrice == null ? (
                              <span className={styles.warn}>ÑÐ¾Ð·Ð´Ð°ÑÑÑÑ</span>
                            ) : (
                              <>
                                {money(t.rulePrice)}
                                {v.price != null && t.rulePrice !== v.price && (
                                  <span className={`${styles.warn} ${styles.diffLine}`}>Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ {deltaText(t.rulePrice, v.price)}</span>
                                )}
                              </>
                            )}
                          </span>
                        ))}
                    </td>
                    <td>
                      <span className={`${styles.status} ${styles[`status_${v.status}`] || ''}`} title={st.hint}>
                        {st.label}
                      </span>
                    </td>
                    <td className={`${styles.sourceCell} ${styles.ellipsis}`} title={`${LINK_SOURCE[v.source] || v.source}${v.author && v.author !== 'Ð°Ð²ÑÐ¾' ? ` Â· ${v.author}` : ''} Â· ${formatShort(v.createdAt)}`}>
                      {LINK_SOURCE[v.source] || v.source} Â· {formatShort(v.createdAt)}
                    </td>
                    <td className={styles.cellActions}>
                      {v.status !== 'ignored' && (
                        <button
                          type="button"
                          className={styles.mini}
                          disabled={busy}
                          title="ÐÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð´Ð»Ñ ÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐ¸"
                          onClick={() => setEditKey(editKey === v.sheetKey ? null : v.sheetKey)}
                        >
                          ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ
                        </button>
                      )}
                      <button
                        type="button"
                        className={confirmKey === v.sheetKey ? styles.miniDanger : styles.mini}
                        disabled={busy}
                        title={
                          v.status === 'ignored'
                            ? 'Ð¡ÑÑÐ¾ÐºÐ° ÑÐ½Ð¾Ð²Ð° Ð±ÑÐ´ÐµÑ ÑÑÐ°ÑÑÐ²Ð¾Ð²Ð°ÑÑ Ð² ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸'
                            : 'Ð¡Ð½ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ: ÑÑÑÐ¾ÐºÐ° Ð²ÐµÑÐ½ÑÑÑÑ Ðº ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ'
                        }
                        onClick={() => unlink(v)}
                      >
                        {v.status === 'ignored'
                          ? confirmKey === v.sheetKey
                            ? 'ÐÐµÑÐ½ÑÑÑ?'
                            : 'ÐÐµÑÐ½ÑÑÑ Ð² ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ'
                          : confirmKey === v.sheetKey
                          ? 'Ð¢Ð¾ÑÐ½Ð¾ Ð¾ÑÐ²ÑÐ·Ð°ÑÑ?'
                          : 'ÐÑÐ²ÑÐ·Ð°ÑÑ'}
                      </button>
                    </td>
                  </tr>
                  {editKey === v.sheetKey && (
                    <tr>
                      <td colSpan={COLUMNS} className={styles.editorRowCell}>
                        <LinkEditor
                          sheetKey={v.sheetKey}
                          problem={{ brand: v.brand, year: v.year }}
                          marks={marks}
                          initial={v.targets}
                          busy={busy}
                          saveText="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ"
                          onSave={(payload) => save(v, payload)}
                          onCancel={() => setEditKey(null)}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
};

export default SheetLinks;
